export default {"src":"https://static.spiritory.com/_next/static/media/3.726bb50b.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};